import React from 'react'

import {
  Div,
  Icon,
  LoadingSpinner,
  Span,
  Text,
  UserCard,
} from '@sendoutcards/quantum-design-ui'
import { sendoutcardsPromotionsUserId } from 'src/app/constants'
import { formatLocation } from 'src/helpers'
import { useState } from 'src/hooks'
import FindMySponsor from 'src/onboarding/components/FindMySponsor'
import { useDetailedCountries, useSponsor } from 'src/react_query'

export const CheckoutFindMySponsor = (props: {
  onSelectedSponsor: (id: string) => void
  isExpanded: boolean
  setIsExpanded: (isExpanded: boolean) => void
  presetSponsorId?: string
}) => {
  const { isExpanded, setIsExpanded, presetSponsorId } = props

  const [sponsorId, setSponsorId] = useState<string | undefined>(
    presetSponsorId,
  )

  const { data: detailedCountries } = useDetailedCountries()

  const fetchedSponsor = useSponsor(
    { id: sponsorId ?? sendoutcardsPromotionsUserId },
    !!sponsorId,
  )

  const sponsorCountry = detailedCountries?.find(
    country =>
      country.postalName === fetchedSponsor.data?.shippingAddress?.country,
  )

  const handleChooseSponsor = (
    sponsorId: string,
    sponsorGenealogyId: string,
  ) => {
    setIsExpanded(false)
    setSponsorId(sponsorId)
    props.onSelectedSponsor(sponsorGenealogyId)
  }

  const handleSponsorSelect = (
    sponsorId: string,
    sponsorGenealogyId: string,
  ) => {
    setSponsorId(sponsorId)
    props.onSelectedSponsor(sponsorGenealogyId)
  }

  return (
    <Div
      display={'flex'}
      flexDirection="column"
      style={{ gap: '8px' }}
      width="100%"
      maxWidth={'640px'}
    >
      {sponsorId && fetchedSponsor.isLoading && (
        <LoadingSpinner size="medium" />
      )}
      {sponsorId && fetchedSponsor.data && !isExpanded && (
        <Div
          onClick={() => {
            setIsExpanded(true)
          }}
          style={{
            backgroundColor: '#f5f6f7',
            padding: '0.5rem',
            borderRadius: '0.5rem',
            cursor: 'pointer',
          }}
        >
          <Text type="caption" weight="semiBold">
            <UserCard
              profileImage={fetchedSponsor.data.storefront?.mugshot?.url}
              firstName={fetchedSponsor.data.firstName}
              lastName={fetchedSponsor.data.lastName}
              size={'small'}
              caption={
                fetchedSponsor.data.shippingAddress
                  ? formatLocation(
                      fetchedSponsor.data.shippingAddress.city,
                      fetchedSponsor.data.shippingAddress.state,
                      sponsorCountry
                        ? sponsorCountry?.alpha2
                        : fetchedSponsor.data.shippingAddress.country,
                    )
                  : ''
              }
              country={
                sponsorCountry
                  ? { isoCode: sponsorCountry.alpha2, callingCode: 1 }
                  : undefined
              }
            />
          </Text>
        </Div>
      )}
      {(!sponsorId || isExpanded) && (
        <>
          <Div
            backgroundColor={'background'}
            display="flex"
            justifyContent={'space-between'}
            inset={'x1'}
            borderRadius="small"
            style={{ gap: '16px' }}
            width="100%"
          >
            <Div display={'flex'} style={{ gap: '16px' }}>
              <Div
                backgroundColor={'foreground'}
                inset="x_5"
                borderRadius={'small'}
                display="flex"
                justifyContent={'center'}
                alignItems="center"
              >
                <Icon name="socLogo" primaryColor={'primaryBrand'} size={24} />
              </Div>
              <Div display="flex" flexDirection="column" style={{ gap: '4px' }}>
                <Text
                  type="caption"
                  color="primaryHeading"
                  weight="semiBold"
                  lineHeight={1}
                >
                  Someone show you this product?
                </Text>
                <Text type="footnote" lineHeight={1}>
                  Optional*
                </Text>
              </Div>
            </Div>

            <Div>
              <Div
                backgroundColor={'foreground'}
                inset="x_5"
                borderRadius={'small'}
                display="flex"
                justifyContent={'center'}
                alignItems="center"
                cursor={'pointer'}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <Span
                  cursor="pointer"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  variants={{
                    expanded: {
                      transform: 'rotate(270deg)',
                    },
                    collapsed: { transform: 'rotate(90deg)' },
                  }}
                  initial={isExpanded ? 'expanded' : 'collapsed'}
                  animate={isExpanded ? 'expanded' : 'collapsed'}
                >
                  <Icon
                    name="chevron"
                    primaryColor="default"
                    orientation="right"
                    size={24}
                  />
                </Span>
              </Div>
            </Div>
          </Div>
          {isExpanded && (
            <Div
              inset="x1"
              display={'flex'}
              flexDirection="column"
              style={{ gap: '16px' }}
            >
              <Text type="caption">
                You can also hear the name “Sponsor”, to refer at the person who
                show you this product, we just want to make sure we give thanks
                to the right person.
              </Text>
              <FindMySponsor
                shouldHideHeading={true}
                onChooseSponsor={handleChooseSponsor}
                onSponsorSelect={handleSponsorSelect}
              />
            </Div>
          )}
        </>
      )}
    </Div>
  )
}
